import { blocks, view } from '@yola/ws-sdk';
import getParentBlockByElement from 'src/js/modules/blocks/helpers/get-parent-block-by-element';
import constants from 'src/js/modules/analytics/segment/constants';
import trackEvent from 'src/js/modules/analytics/segment/trackers/track-event';

const trackPhotoStockSearchPerformed = ({ targetElementId, searchTerm, searchResults }) => {
  if (!searchTerm.trim()) return;

  const element = view.accessors.getLiveElement(targetElementId);
  const targetElement = getParentBlockByElement(element);
  const targetBlockId = blocks.accessors.getBlockIdByElement(targetElement);
  const targetBlockVariationId = blocks.accessors.getVariationIdByElement(targetElement);

  trackEvent(constants.events.PHOTO_STOCK_SEARCH_PERFORMED, {
    targetBlockId,
    targetBlockVariationId,
    searchTerm,
    searchResults,
  });
};

export default trackPhotoStockSearchPerformed;
